import { useEffect, useState } from 'react';
import MainFrameLeftSection from '../mainFrame/mainFrameLeftSection';
// eslint-disable-next-line import/no-cycle
import MainFrameRightSection from '../mainFrame/mainFrameRightSection';
import MainFrame from '../mainFrame/mainFrame';
import styles from '../mainFrame/mainPage.module.css';
import { Folder } from '../../services/http/folder.api';
import { Document } from '../../services/http/documents.api';
import { useSearchBarContext } from '../../store/searchBar.store';

/**
 * 選択された関連ドキュメントのプロップスインターフェース
 */
export interface ChooseRelatedDocumentProps {
  /** 関連文書が選択されたときに呼び出される関数 */
  onChooseRelatedDocuments: (documents: Document[]) => void,
  /** 関連文書の追加がキャンセルされたときに呼び出される関数 */
  onCancelAddingRelatedDocuments: () => void,
}

/**
 * 選択された関連ドキュメントのコンポーネント
 */
function ChooseRelatedDocument({ onChooseRelatedDocuments = () => {}, onCancelAddingRelatedDocuments = () => {} }: ChooseRelatedDocumentProps) {
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>(null);
  const [changingFolderPermissions, setChangingFolderPermissions] = useState(false);

  const searchBarContext = useSearchBarContext();

  useEffect(() => {
    if (selectedFolder?.id) {
      setChangingFolderPermissions(false);
    }
  }, [selectedFolder]);

  useEffect(() => {
    searchBarContext.setIsAttachingDocumentSearch(true);
    return () => {
      searchBarContext.setIsAttachingDocumentSearch(false);
    };
  }, []);

  return (
    <div className={styles.attachDocSection}>
      <MainFrame
        borderBox
        body={(
          <div className={styles.mainFrame}>
            <div className={styles.mainSections}>
              {!searchBarContext.isSearching && (
                <MainFrameLeftSection
                  hideTopButton
                  folder={selectedFolder}
                  onSelectFolder={(e) => {
                    searchBarContext.setIsSearching(false);
                    setSelectedFolder(e);
                  }}
                  isChangingFolderPermissions={changingFolderPermissions}
                />
              )}
              <MainFrameRightSection
                onChooseRelatedDocuments={(e) => {
                  onChooseRelatedDocuments(e);
                }}
                isAttachingDocument
                folder={selectedFolder}
                onChangingFolderPermissions={() => setChangingFolderPermissions(true)}
                onCancelAddingRelatedDocuments={onCancelAddingRelatedDocuments}
              />
            </div>
          </div>
  )}
      />
    </div>
  );
}

export default ChooseRelatedDocument;
